import React from "react";
import "./clients.css"
import image from "../assets/developers.jpg"


function Clients() {
  return (
<div class="clients-section" id="#clients">
    <h2>Our Clients</h2>
    <div class="client-container">
        <div class="client client1" >
            <a href='#'>Small Businesses</a>
        </div>
        <div class="client client3" >
            <a href='#'>Midsize Businesses</a>
        </div>
        <div class="client client4" >
            <a href='#'>Multinational Companies</a>
        </div>
        <div class="client client2" >
            <a href='#'>Institutions</a>
        </div>
    </div>
</div>

  );
}

export default Clients;
